<template>
  <div id="app" class="app">
    <router-view name="header"/>
    <div class="wrapper">
      <router-view/>
    </div>
    <router-view name="footer"/>
  </div>
</template>
<script>
  import { metaGeneral } from '@/utils/meta';

  export default {
    name: 'app',
    metaInfo: {
      titleTemplate: '%s | mathiasmoeller.com | Nature & Travel Photography',
      meta: [
        ...metaGeneral(),
      ],
    },
  };
</script>
<style lang="scss">
  @import "./App.scss";

  body, html, .app {
    height: 100%;
  }

  .app {
    display: flex;
    flex-direction: column;
  }

  .wrapper {
    flex-grow: 1;
  }
</style>
